import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { checkSelfUpdate, fetchAnno, GlobalLoadingContext, useThrottledHandler } from 'App';
import { Button, Form, Input } from 'antd';
import { Ellipsis, FloatingPanel, Grid, Image, Modal, Swiper, SwiperRef, Switch, Toast } from 'antd-mobile';
import { getRealVersion } from 'app/constant';
import img from 'app/img';
import LevelInfo from 'components/dot/level-info';
import ShareCypher, { ShareCypherDT } from 'components/dot/shareCypher';
import dayjs from 'dayjs';
import { useI18n } from 'i18n/useI18n';
import { useContext, useEffect, useRef, useState } from 'react';
import {
  AiOutlineExpand,
  AiOutlineGift,
  AiOutlineKey,
  AiOutlineLeft,
  AiOutlineLock,
  AiOutlineQuestionCircle,
  AiOutlineRight,
  AiOutlineSearch,
  AiOutlineShareAlt,
  AiOutlineUser,
} from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import VideoApi, { VideoDataType } from 'services/apis/cnt/video-api';
import CypherApi, { CyhersDataType } from 'services/apis/cnt2/cypher-api';
import PostsApi, { PagePostDT } from 'services/apis/cnt2/post-api';
import AnnoApi, { AnnoDataType } from 'services/apis/ope/anno-api';
import UserApi, { UserPolyInfoDT } from 'services/apis/sys/user-api';
import BillApi, { BillDataType } from 'services/apis/usr/bill-api';
import ClockApi, { ClockDataType } from 'services/apis/usr/clock-api';
import InviteApi, { InviteDataType } from 'services/apis/usr/invite-api';
import UserDetailApi, { UserDetailDataType } from 'services/apis/usr/user-detail-api';
import UserGroupApi, { UserGroupDataType } from 'services/apis/usr/user-group-api';
import VideoListApi from 'services/apis/usr/video-list-api';
import { postSourceTypeMap } from 'services/gather_bo/_total';
import { bizBaseUrl } from 'services/request';
import { getBrowserFinger } from 'utils/browserFingerUtil';
import { copy2Clipboard, readClipboard } from 'utils/clipboardUtil';
import { localDatetime2Date } from 'utils/dateUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import RegUtil from 'utils/regUtil';
import PayModal from '../page_one/mine/center/PayModal';
import myStyles from './index.module.scss';

const Sesame = () => {
  const [initialHeight, setInitialHeight] = useState<number>(window.outerHeight); // 页面打开时肯定没有虚拟键盘
  useEffect(() => {
    // 弹起虚拟键盘时，高度会变，因此需要初始化
    setInitialHeight(window.innerHeight);
  }, []);
  const navigate = useNavigate();
  const { t } = useI18n();

  const [postSwiperIndex, setPostSwiperIndex] = useState(0);
  const postSwipeRef = useRef<SwiperRef>(null);
  const [doSearch, setDoSearch] = useState(false);
  const [cypherKey, setCypherKey] = useState<string>();
  const [cypherData, setCypherData] = useState<CyhersDataType>(null);
  const [unlockedMode, toggleUnlockedMode] = useState<boolean>(false);

  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;
  const globalLoading = useContext(GlobalLoadingContext).globalLoading;

  const floatingPanelRef = useRef(null);
  const resetPanel = () => {
    if (floatingPanelRef.current) {
      // 通过 Ref 调用 FloatingPanel 的 setHeight 方法
      floatingPanelRef.current.setHeight(115, { immediate: true });
    }
  };

  // const [postDelock, setPostDelock] = useState(false);

  // 浏览器指纹
  const [userBrowserPrint, setUserBrowserPrint] = useState<string>();
  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;
  const userId = userPolyInfo.asUser.uuid;
  const username = userPolyInfo.asUser.username;
  const collectListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'collect').uuid;
  const historyListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'history').uuid;
  const favoritelistId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'favorite').uuid;

  const [collectList, setCollectList] = useState<VideoDataType[]>();
  const [historyList, setHistoryList] = useState<VideoDataType[]>();

  const navigate2Detail = (post: any, termId: string) => {
    navigate('/detail', {
      state: {
        post: post,
        term: { termUuid: termId },
        isFromSesame: true,
      },
    });
  };

  // 分享助力
  const [mimeShareCypher, setMimeShareCypher] = useState<ShareCypherDT>(null);
  const shareCypher = async (data: ShareCypherDT) => {
    setMimeShareCypher(data);
    setShowShareModal(true);
  };

  useEffect(() => {
    getBrowserFinger().then((data) => {
      setUserBrowserPrint(data.fingerprint);
    });
  }, []);

  const [todayOverGift, setTodayOverGift] = useState<boolean>(true);
  const fetchTodayOverGift = async () => {
    UserDetailApi.todayOverGift(userId).then((resp) => {
      if (resp.successful) {
        setTodayOverGift(resp.result);
      }
    });
  };

  const [todayOverSign, setTodayOverSign] = useState<ClockDataType>(null);
  const getTodayOverSign = async () => {
    ClockApi.todayOverSign(userId).then((resp) => {
      if (resp.successful && resp.result) {
        setTodayOverSign(resp.result);
      }
    });
  };

  const [userPoint, setUserPoint] = useState<number>(userPolyInfo.asUserDetail.userPoints);
  const getUserPoint = async () => {
    UserDetailApi.getByUserId(userId).then((resp) => {
      if (resp.successful && resp.result) {
        const result: UserDetailDataType = resp.result;
        setUserPoint(result.userPoints);
      }
    });
  };

  const helpCypher = async (cypherKey: string) => {
    const userBrowserPrint = (await getBrowserFinger()).fingerprint;
    console.log('userBrowserPrint', userBrowserPrint);
    CypherApi.helpCypher({
      userId: userId,
      browserFinger: userBrowserPrint,
      cypherKey: cypherKey,
    }).then((resp) => {
      if (!resp.successful) {
        Toast.show(resp.msg);
      } else {
        // Toast.show('已为好友助力');
      }
    });
  };

  const crackCypher = async (userId: string, postId: string) => {
    CypherApi.crackCypher({
      userId: userId,
      postId: postId,
    }).then((resp) => {
      if (!resp.successful) {
        Toast.show(resp.msg);
      } else {
        // Toast.show('已解锁');
        getRemainCrackTimesMap();
        fetchCollect('history');
        getUserPoint();
      }
    });
  };

  // 接口返回的Map会被接收为普通的js对象（不是json），要通过new Map(Object.entries(resp.result))转为map对象
  const [overCrackTimesMap, setOverCrackTimesMap] = useState<Map<string, number>>(new Map());
  const getRemainCrackTimesMap = async () => {
    CypherApi.mineCypher({ userId: userId }).then((resp) => {
      if (resp.successful && resp.result) {
        // console.log('overCrackTimesMap', resp.result);
        // console.log("overCrackTimesMap2", new Map(resp.result));
        // console.log('overCrackTimesMap3', new Map(Object.entries(resp.result)));
        setOverCrackTimesMap(new Map(Object.entries(resp.result)));
      }
    });
  };

  // 解析口令
  const parseCypher = async (cypherKey: string) => {
    const resp = await CypherApi.parseCypher({ userId: userId, cypherKey: cypherKey }, {});
    if (!resp.successful) {
      Toast.show(resp.msg);
      return;
    }
    const cypherData: CyhersDataType = resp.result;
    console.log('cypher', cypherData);
    setCypherData(cypherData);
    setDoSearch(false);
    // 添加到历史
    console.log(userId, userPolyInfo);
    await VideoApi.add2List({
      postId: cypherData.fkPostId,
      videoListId: historyListId,
    });
  };

  // 获取列表
  const fetchCollect = async (listType: string) => {
    const result = await VideoListApi.listWithType(listType === 'collect' ? collectListId : historyListId, []);
    if (result.code === 0 && result.successful) {
      if (listType === 'collect') setCollectList(result.result);
      if (listType === 'history') setHistoryList(result.result);
    } else {
      Toast.show(t('collect.index.863806-0'));
    }
  };

  const getRealCypher = (text: string) => {
    return text?.replace(/[^A-Z0-9]/g, '')?.slice(0, 10);
  };

  // 监听页面焦点
  useEffect(() => {
    // 当页面获取焦点时
    const handleFocus = () => {
      // console.log('页面获得焦点');
      // 执行你需要在页面获取焦点时的操作
      readClipboard().then((text) => {
        const realCypher = getRealCypher(text);
        // 代号D760特别行动中，我方击败A295号生化个体，获得FC级圣遗物。
        // 代号312F特别行动中，我方击败66B5号生化个体，获得E7级圣遗物。
        // 代号57CF特别行动中，我方击败4867号生化个体，获得1F级圣遗物。
        // 9C48B11F61
        const regex = /^代号[A-Z0-9]{4}特别行动中，我方击败[A-Z0-9]{4}号生化个体，获得[A-Z0-9]{2}级圣遗物。$/;
        const regexPure = /^[A-Z0-9]{10}$/;
        if (!regex.test(text)) {
          console.log(`未从文本 ${text} 识别到口令 ${realCypher}`);
          return;
        }
        // 先清除其他
        Modal.clear();
        Modal.show({
          title: (
            <div className=" flex justify-center items-center gap-1">
              <div>识别到口令</div>
              <AiOutlineKey
                color="orange"
                size={22}
              />
            </div>
          ),
          closeOnAction: true,
          closeOnMaskClick: true,
          content: (
            <>
              <div className=" bg-gradient-to-tr from-slate500/50 to-slate-500/80 p-2 m-2">{text}</div>
            </>
          ),
          actions: [
            {
              key: 'submit',
              text: '查看',
              onClick: () => {
                copy2Clipboard(`【已识别口令】${text}`);
                // 输入框设置口令，查看口令资源，为TA助力
                setCypherKey(realCypher);
                parseCypher(realCypher);
                helpCypher(realCypher);
                // 重置面板，关闭其他对话框
                resetPanel();
                setShowGiftModal(false);
                setShowRecordsModal(false);
                setShowShareModal(false);
              },
            },
          ],
        });
      });
    };

    // 当页面失去焦点时
    const handleBlur = () => {
      // console.log('页面失去焦点');
      // 执行你需要在页面失去焦点时的操作
    };

    // 添加事件监听器
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    // 清理事件监听器，防止内存泄漏
    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []); // 空数组表示该 effect 只会在组件挂载和卸载时执行

  // 网络请求
  useEffect(() => {
    // 已解锁帖子
    getRemainCrackTimesMap();
    // 今日是否签到
    getTodayOverSign();
    // 我的点数
    getUserPoint();
    // 今日是否领取盲盒
    fetchTodayOverGift();
    // 获取记录
    fetchRecordList();
    // navigate("/one");
    // 0 收藏 进入页面时获取一次
    fetchCollect('collect');
    // 1 历史 进入页面时获取一次，浮动面板拖动后刷新
    fetchCollect('history');
    // 2 喜欢 不需要获取这个列表
    // fetchCollect("like");
  }, []);

  const [showGiftModal, setShowGiftModal] = useState<boolean>(false);
  const [giftModalData, setGiftModalData] = useState<PagePostDT[]>([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const changeGiftTimes = useRef(3);
  const GiftModal = () => {
    return (
      <>
        <Modal
          title="今日盲盒"
          visible={showGiftModal}
          closeOnAction={false}
          closeOnMaskClick={false}
          showCloseButton={false}
          content={
            <>
              <Grid
                columns={2}
                gap={5}
              >
                {giftModalData.map((item, index) => (
                  <Grid.Item
                    key={item.postUuid + index}
                    className={[
                      ' text-white bg-purple-500/60 rounded-md shadow-md text-center overflow-hidden flex flex-col justify-center items-center',
                    ].join(' ')}
                  >
                    <div className=" relative w-full p-0.5">
                      <Image
                        src={item.postCoverUrlList[0]}
                        fit="cover"
                        className=" rounded-t-md w-full aspect-square"
                        fallback={<img src={img.loadingImg} />}
                        placeholder={<img src={img.loadingImg} />}
                      />
                      <div className=" p-1 absolute top-0.5 right-0.5 rounded-md bg-orange-500 bg-opacity-80 shadow-md text-xs/3">
                        {postSourceTypeMap.get(item.postSourceType)}
                      </div>
                      {/* 标题 */}
                      <div className=" rounded-b-md px-2 py-1 text-[10px]/3 left-0 w-full h-[29px] overflow-hidden bg-gradient-to-r from-bla/80 to-bla/30 bg-opacity-50">
                        <div>{item.postTitle}</div>
                      </div>
                    </div>
                  </Grid.Item>
                ))}
              </Grid>
              <div
                className={[
                  ' py-2 mt-2 flex items-center justify-center bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white px-2 rounded-md shadow-md',
                ].join(' ')}
                onClick={useThrottledHandler(() => {
                  if (globalLoading) {
                    return;
                  }
                  showGlobalLoading();

                  UserDetailApi.saveGift({
                    userId: userId,
                    listId: historyListId,
                    postIdList: giftModalData.map((item) => item.postUuid),
                  }).then((resp) => {
                    if (resp.successful) {
                      Toast.show('已领取');
                      // 关闭弹窗
                      setShowGiftModal(false);
                      // 隐藏盲盒
                      setTodayOverGift(true);
                    } else {
                      Toast.show(resp.msg);
                    }
                  });
                })}
              >
                <div className=" mt-0 text-nowrap text-base">一键领取</div>
              </div>
              <div
                className={[
                  ' py-2 mt-2 flex items-center justify-center bg-gradient-to-r from-violet-400 to-fuchsia-400 text-white px-2 rounded-md shadow-md',
                ].join(' ')}
                onClick={useThrottledHandler(() => {
                  if (changeGiftTimes.current <= 0) {
                    Toast.show('不能再换了~');
                    return;
                  }
                  if (globalLoading) {
                    return;
                  }
                  showGlobalLoading({ long: true });

                  PostsApi.pageOsusume({ termId: null, count: 4 }).then((resp) => {
                    if (resp.successful) {
                      // 显示盲盒内容
                      const result: PagePostDT[] = resp.result.records;
                      setGiftModalData(result);
                      setShowGiftModal(true);
                      changeGiftTimes.current -= 1;
                    }
                  });
                })}
              >
                <div className=" mt-0 text-nowrap text-base">{`换一换(${changeGiftTimes.current})`}</div>
              </div>
            </>
          }
        />
      </>
    );
  };

  const [showRecordsModal, setShowRecordsModal] = useState(false);
  type RecordDT = {
    time: string;
    label: string;
  };
  const recordsSwiperRef = useRef<SwiperRef>(null);
  const [recordSwiperIndex, setRecordSwiperIndex] = useState(0);
  const [signList, setSignList] = useState<RecordDT[]>([]);
  const [billList, setBillList] = useState<RecordDT[]>([]);
  const [inviteList, setInviteList] = useState<RecordDT[]>([]);

  const fetchRecordList = () => {
    fetchSignList();
    fetchBillList();
    fetchInviteList();
  };
  const fetchSignList = () => {
    // 签到记录
    ClockApi.userSignList(userId).then((resp) => {
      if (resp.successful) {
        const result: ClockDataType[] = resp.result;
        const signList = result.map((item) => {
          return {
            time: dayjs(localDatetime2Date(item.clockDatetime)).format('YYYY-MM-DD'),
            label: item.awardTips,
          };
        });
        setSignList(signList);
      }
    });
  };
  const fetchBillList = () => {
    // 点数记录
    BillApi.listByUserId(userId).then((resp) => {
      if (resp.successful) {
        const result: BillDataType[] = resp.result;
        const billList = result.map((item) => {
          return {
            time: dayjs(localDatetime2Date(item.billDatetime)).format('YYYY-MM-DD'),
            label: item.billRemark,
          };
        });
        setBillList(billList);
      }
    });
  };
  const fetchInviteList = () => {
    // 邀请记录
    InviteApi.listByUserId(userId).then((resp) => {
      if (resp.successful) {
        const result: InviteDataType[] = resp.result;
        const signList = result.map((item) => {
          return {
            time: dayjs(localDatetime2Date(item.inviteDatetime)).format('MM-DD hh:mm'),
            label: item.inviteUsername,
          };
        });
        setInviteList(signList);
      }
    });
  };

  // 记录弹窗
  const RecordModal = () => {
    return (
      <>
        <Modal
          visible={showRecordsModal}
          showCloseButton={false}
          closeOnAction={true}
          closeOnMaskClick={true}
          onClose={() => {
            setShowRecordsModal(false);
          }}
          destroyOnClose={true}
          title={
            <>
              <div className="  w-full text-base flex items-center justify-around">
                {['签到记录', '点数记录', '邀请记录'].map((item, index) => (
                  <b
                    key={item + index}
                    className={[
                      recordSwiperIndex == index &&
                        ' bg-gradient-to-br from-purple-500/50 to-pink-500/50 text-white rounded-md shadow-md ',
                      ' p-1',
                    ].join(' ')}
                    onClick={() => {
                      recordsSwiperRef.current?.swipeTo(index);
                      setRecordSwiperIndex(index);
                    }}
                  >
                    {item}
                  </b>
                ))}
              </div>
            </>
          }
          content={
            <>
              <Swiper
                ref={recordsSwiperRef}
                defaultIndex={recordSwiperIndex}
                indicator={(total, index) => <></>}
                onIndexChange={(index) => {
                  setRecordSwiperIndex(index);
                }}
              >
                {[signList, billList, inviteList].map((recordList, index) => (
                  <Swiper.Item
                    key={recordList.length + index}
                    className=" px-1 text-sm"
                    style={{ minHeight: window.innerWidth }}
                  >
                    {(!recordList || recordList.length == 0) && (
                      <>
                        <div className=" bg-purple-500/70 text-white p-5 m-5 text-center rounded-md shadow-md">
                          暂无记录
                        </div>
                      </>
                    )}
                    {recordList?.map((item, index) => (
                      <div
                        key={item.label}
                        className={[
                          index % 2 == 0 && ' bg-purple-500/70 text-white',
                          index % 2 == 1 && ' bg-violet-500/30',
                          ' text-nowrap whitespace-nowrap flex justify-between items-center p-2 my-1 rounded-md shadow-md',
                        ].join(' ')}
                      >
                        <div>{item.time}</div>
                        <div>{item.label}</div>
                      </div>
                    ))}
                  </Swiper.Item>
                ))}
              </Swiper>
            </>
          }
        />
      </>
    );
  };

  const limitCount = 99;

  const [loginType, setLoginType] = useState<number>(0);
  const LoginModal = () => {
    return (
      <Modal
        visible={loginType != 0}
        title={loginType == 1 ? '注册用户' : '登录用户'}
        closeOnAction={false}
        closeOnMaskClick={true}
        showCloseButton={true}
        onClose={() => {
          setLoginType(0);
        }}
        content={
          <>
            <div className="">
              <Form
                name="login"
                initialValues={{ remember: true, autologin: true }}
                onFinish={async (values) => {
                  const data = {
                    fingerprint: userBrowserPrint,
                    username: values.username,
                    password: values.password,
                  };
                  console.log('onFinish:', values);
                  console.log('data:', data);
                  const resp = await UserApi.setUserPassword(data);
                  if (!resp.successful) {
                    Toast.show(resp.msg);
                  } else {
                    Toast.show('注册成功');
                    setLoginType(0);
                    setTimeout(() => {
                      LiveUpdate.reload();
                    }, 3000);
                  }
                }}
                // onFinishFailed={(errorInfo) => {
                //   console.log('onFinishFailed:', errorInfo);
                // }}
                className=" w-full px-2 mt-4"
              >
                <Form.Item
                  id="username"
                  name="username"
                  required={true}
                  // className=" -mt-2"
                  rules={[
                    { required: true, message: '请输入账号' },
                    { max: 16, message: '账号最长16位' },
                    { pattern: RegUtil.usernameRegexp, message: RegUtil.usernameRegTip },
                  ]}
                >
                  <Input
                    addonBefore={<>账号</>}
                    size="large"
                    maxLength={16}
                    prefix={<AiOutlineUser size={20} />}
                    placeholder="请输入账号"
                  />
                </Form.Item>
                <Form.Item
                  id="password"
                  name="password"
                  // className=" -mt-2"
                  required={true}
                  rules={[
                    { required: true, message: '请输入密码' },
                    { max: 16, message: '密码最长16位' },
                    { pattern: RegUtil.passwordRegexp, message: RegUtil.passwordRegTip },
                  ]}
                >
                  <Input.Password
                    addonBefore={<>密码</>}
                    maxLength={16}
                    size="large"
                    prefix={<AiOutlineLock size={20} />}
                    placeholder="请输入密码"
                  />
                </Form.Item>
                <div className=" text-sm text-slate-700 mb-4">* 账号不可修改，请妥善保管</div>
                {/* <Compact className=" flex justify-around items-center ">
                <Form.Item
                  labelAlign="right"
                  name="remember"
                  valuePropName="checked"
                  label={null}
                >
                  <Checkbox>记住用户</Checkbox>
                </Form.Item>
                <Form.Item
                  labelAlign="right"
                  name="autologin"
                  valuePropName="checked"
                  label={null}
                >
                  <Checkbox>自动登录</Checkbox>
                </Form.Item>
              </Compact> */}
                <Form.Item className=" flex justify-center items-center">
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className=" bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white "
                  >
                    确认提交
                  </Button>
                </Form.Item>
                {/* 没想好和设备间的绑定关系 */}
                {/* {loginType == 1 ? (
                  <>
                    <center
                      className=" -mt-2"
                      onClick={() => {
                        setLoginType(2);
                      }}
                    >
                      <Button type="link">已有账号? 去登录</Button>
                    </center>
                  </>
                ) : (
                  <>
                    <center className=" -mt-2">
                      <Button
                        type="link"
                        onClick={() => {
                          setLoginType(1);
                        }}
                      >
                        没有账号? 去注册
                      </Button>
                    </center>
                  </>
                )} */}
              </Form>
              <div
                onClick={() => {
                  //
                }}
                className=" pointer-events-none w-full z-0 absolute ring-0 bottom-0 flex justify-end items-center"
              >
                <img
                  src={img.cute_cat}
                  className=" w-20 h-16 object-cover object-top mr-4"
                />
              </div>
            </div>
          </>
        }
      />
    );
  };

  const [baseUsergroup, setBaseUsergroup] = useState<UserGroupDataType>(null);
  const [selectUsergroup, setSelectUsergroup] = useState<UserGroupDataType>(null);
  const [showLevelupModel, setShowLevelupModel] = useState(false);
  const LevelupModel = () => {
    return (
      <Modal
        visible={showLevelupModel}
        title={'升级会员'}
        closeOnAction={false}
        closeOnMaskClick={true}
        showCloseButton={false}
        onClose={() => {
          setShowLevelupModel(false);
        }}
        content={
          <>
            <LevelInfo
              userGroup={baseUsergroup}
              selectUsergroup={(usergroup: UserGroupDataType) => {
                setShowLevelupModel(false);
                setSelectUsergroup(usergroup);
              }}
            />
          </>
        }
      />
    );
  };

  // 获取基础会员组信息
  useEffect(() => {
    UserGroupApi.getByLevel(10 + '').then((resp) => {
      // console.log('fetchBaseUsergroup', resp);
      if (resp.successful) {
        setBaseUsergroup(resp.result);
      }
    });
  }, []);

  // 页面内容
  return (
    <>
      {/* 登录弹窗 */}
      <LoginModal />
      {/* 升级弹窗 */}
      <LevelupModel />
      {/* 支付弹窗 */}
      {selectUsergroup && (
        <>
          <PayModal
            selectUsergroup={selectUsergroup}
            userId={userPolyInfo?.asUser.uuid}
            closePayModel={() => {
              setSelectUsergroup(null);
            }}
          />
        </>
      )}
      {/* 口令弹窗 */}
      <ShareCypher
        mimeShareCypher={mimeShareCypher}
        showShareModal={showShareModal}
        setShowShareModal={(openModal) => {
          setShowShareModal(openModal);
        }}
      />
      {/* 礼物弹窗 */}
      <GiftModal />
      {/* 记录弹窗 */}
      <RecordModal />
      <div
        className="bg-[#03030F] w-full h-full "
        style={{ height: initialHeight }}
      >
        {/* 顶部 */}
        <div className=" relative">
          {/* 头图 */}
          <div
            style={{
              backgroundImage: 'url(' + img.sesamaTop + ')',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              width: '100%',
              height: window.innerWidth / 2.5,
            }}
          />
          {/* 模式切换 */}
          <div className=" absolute top-2 right-0">
            {false ? (
              <>
                <div
                  className=" px-2 py-1 bg-gradient-to-r from-orange-500/90 to-yellow-400/90 text-white rounded-xl shadow-md"
                  onClick={() => {
                    navigate('/one');
                  }}
                >
                  解锁模式
                </div>
              </>
            ) : (
              <>
                <Switch
                  checked={unlockedMode}
                  defaultChecked={false}
                  className={myStyles.customCss}
                  uncheckedText="限制模式"
                  checkedText="解锁模式"
                  style={{
                    '--checked-color': '#FB923C',
                    transform: 'scale(0.8)',
                  }}
                  onChange={(e) => {
                    if (!unlockedMode) {
                      if (prompt('请输入解锁码', '') == 'admin12345') {
                        toggleUnlockedMode(!unlockedMode);
                        // setTimeout(() => {
                        navigate('/one');
                        // }, 1500);
                      } else {
                        Toast.show('❤ 解锁码无效 ❤');
                        return;
                      }
                    }
                  }}
                />
              </>
            )}
          </div>
          {/* 注册用户 */}
          <div className=" absolute top-10 right-2">
            <div
              style={{
                transform: 'scale(0.95)',
              }}
              className=" bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white px-4 py-1 inline-block rounded-2xl shadow-md text-nowrap"
              onClick={useThrottledHandler(() => {
                setLoginType(1);
              })}
            >
              注册用户
            </div>
          </div>
          {/* 搜索框 */}
          <div className=" opacity-90 text-base flex items-center justify-between gap-2 rounded-2xl shadow-md bg-slate-100 border-sky-200 mx-4 mt-0 mb-2 py-2 px-3">
            <AiOutlineSearch
              size={28}
              color="orange"
            />
            <input
              placeholder="请输入资源口令"
              className="  text-[#03030F] w-[12rem] grow text-lg border-black py-1 bg-transparent tracking-[0.2rem] text-center rounded-md"
              value={cypherKey}
              onKeyDownCapture={useThrottledHandler((e) => {
                if (e.key == 'Enter' && cypherKey?.length == 10) {
                  parseCypher(cypherKey);
                  helpCypher(cypherKey);
                }
              })}
              onPaste={(e) => {
                console.log('onPaste', e.clipboardData.getData('text'));
                // 获取粘贴的内容
                let paste = e.clipboardData.getData('text');
                // 将过滤后的内容放入输入框
                setCypherKey(getRealCypher(paste));

                // 阻止其他事件
                e.preventDefault();
                e.stopPropagation();
              }}
              onInput={(e) => {
                console.log('onInput', e.currentTarget.value);
                if (!e.currentTarget.value) {
                  setDoSearch(false);
                  setCypherKey('');
                  setCypherData(null);
                  return;
                }
                setCypherKey(getRealCypher(e.currentTarget.value));

                // 阻止其他事件
                e.preventDefault();
                e.stopPropagation();
              }}
              // 聚焦时还原出事高度，防止遮挡内容
              onFocus={() => {
                resetPanel();
              }}
              maxLength={10}
            />
            <div
              className=" -mr-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white px-2.5 py-1 inline-block rounded-md shadow-md text-base text-nowrap"
              onClick={useThrottledHandler(() => {
                if (cypherKey?.length == 10) {
                  parseCypher(cypherKey);
                  helpCypher(cypherKey);
                }
              })}
            >
              查看
            </div>
          </div>
        </div>
        {/* 用户名，获取更多资源，版号 */}
        <div className=" text-slate-400 text-sm w-full text-center">
          <div className="inline-block">
            <span className=" text-red-300">
              {userPolyInfo.vipList.length != 0
                ? '[会员] '
                : userPolyInfo.asUser.overRegister == 1
                  ? '[用户] '
                  : '[游客] '}
            </span>
            {username}
          </div>
          <div
            className=" m-3 text-orange-300 inline-block"
            onClick={useThrottledHandler(() => {
              fetchAnno('sesameAnno');
            })}
          >
            获取更多资源
          </div>
          <AiOutlineQuestionCircle
            className=" inline-block mb-0.5"
            size={16}
            onClick={useThrottledHandler(async () => {
              Modal.show({
                closeOnAction: true,
                closeOnMaskClick: true,
                style: { zIndex: 999 },
                content: (
                  <div>
                    <Ellipsis
                      className=" text-center"
                      rows={1}
                      direction="middle"
                      content={await getRealVersion()}
                    />
                    <div className=" w-full flex justify-center items-center ">
                      <div
                        className=" mt-2 px-4 py-2 text-white bg-slate-500 shadow-md rounded-md"
                        onClick={() => {
                          if (globalLoading) {
                            return;
                          }
                          showGlobalLoading();

                          checkSelfUpdate(true);
                        }}
                      >
                        检测
                      </div>
                    </div>
                  </div>
                ),
              });
            })}
          />
          {/* <div
            className="inline-block"
            onClick={() => {
              setPostDelock(!postDelock);
            }}
          >
            {postDelock ? "一键加锁" : "一键解锁"}
          </div> */}
        </div>
        {/* 口令资源 */}
        <div
          className={[
            'text-white rounded-2xl text-center shadow-md px-0 m-4 mt-2 bg-opacity-20 text-base flex flex-col justify-center items-center gap-4',
          ].join(' ')}
          style={{ height: initialHeight * 0.3 }}
        >
          {doSearch || !cypherData ? (
            <div className="w-full h-full flex justify-center items-center ">
              <div
                style={{
                  backgroundImage: 'url(' + img.cuteAvatar + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                  width: initialHeight * 0.3,
                  height: initialHeight * 0.3,
                }}
              />
            </div>
          ) : (
            <>
              <div className=" relative">
                <div className=" pt-2 bg-gradient-to-b from-slate-200/20 to-slate-100/10 rounded-3xl shadow-md">
                  {/* 封面 */}
                  <div className={[' relative inline-block '].join(' ')}>
                    <Image
                      src={cypherData.postCover
                        ?.replaceAll('\\', '/')
                        .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                      className=" rounded-2xl"
                      style={{ filter: 'blur(3px) brightness(0.75)' }}
                      width={Math.floor(initialHeight * 0.2)}
                      height={Math.floor(initialHeight * 0.2)}
                      fit="cover"
                      lazy={true}
                      fallback={
                        <div
                          style={{
                            background: 'url(' + img.fallbackVerticalImg + ') center center / cover no-repeat',
                            height: Math.floor(initialHeight * 0.2),
                            width: Math.floor(initialHeight * 0.2),
                          }}
                          className=" rounded-2xl"
                        />
                      }
                      placeholder={
                        <div
                          style={{
                            background: 'url(' + img.loadingImg + ') center center / cover no-repeat',
                            height: Math.floor(initialHeight * 0.2),
                            width: Math.floor(initialHeight * 0.2),
                          }}
                          className=" rounded-2xl"
                        />
                      }
                    />
                    <div className=" text-xs absolute top-0 right-0 p-1.5 rounded-md rounded-tr-2xl bg-orange-500 bg-opacity-90 shadow-md">
                      {postSourceTypeMap.get(cypherData.postSourceType)}
                    </div>
                  </div>
                  {/* 标题 */}
                  <Ellipsis
                    rows={2}
                    content={cypherData.postTitle}
                    className=" text-sm/4 px-4 pb-2"
                    style={{ width: Math.floor(window.innerWidth * 0.7) }}
                  />
                </div>
                {/* 蒙版 */}
                <div
                  className={[
                    // 助力次数>=3，表示已解锁
                    // 否则未解锁（未持有口令/助力次数不足）
                    !(overCrackTimesMap.get(cypherData?.fkPostId) >= 3) ? 'visible' : 'hidden',
                    ' text-sm bg-black bg-opacity-60 w-full h-full absolute top-0 left-0 rounded-xl shadow-md flex flex-col justify-center items-center',
                  ].join(' ')}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <div>
                    还需
                    <span className=" inline-block pl-2 pr-1.5 py-0.5 mr-1 shadow-sm rounded-sm bg-slate-500">
                      {3 - (overCrackTimesMap.get(cypherData?.fkPostId) || 0)}
                    </span>
                    助力
                  </div>
                  <div
                    className=" underline underline-offset-4 text-white text-sm mt-2"
                    onClick={() => {
                      if (globalLoading) {
                        return;
                      }
                      showGlobalLoading();

                      crackCypher(userId, cypherData.fkPostId);
                    }}
                  >
                    点数解锁
                  </div>
                </div>
              </div>
              {/* 交互 */}
              <div className=" flex items-center justify-between gap-3">
                {/* 查看资源 */}
                {overCrackTimesMap.get(cypherData?.fkPostId) >= 3 && (
                  <>
                    <div
                      className={[
                        ' flex items-center justify-center gap-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white px-2 py-2 rounded-md shadow-md text-base',
                      ].join(' ')}
                      onClick={() => {
                        navigate2Detail(
                          {
                            postUuid: cypherData.fkPostId,
                            postTitle: cypherData.postTitle,
                            postCoverUrlList: [cypherData.postCover],
                          },
                          cypherData.fkTermId
                        );
                      }}
                    >
                      <AiOutlineExpand size={20} />
                      <div className=" mt-0 text-nowrap whitespace-nowrap text-sm">查看资源</div>
                    </div>
                  </>
                )}
                {/* 为TA助力，让用户区分是利己还是利他是困难的，查看资源时自动助力 */}
                {/* {cypherData.fkUserId !== userId && (
                  <div
                    className=" flex items-center justify-center gap-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-2 py-2 rounded-md shadow-md text-base"
                    onClick={() => {
                      if (globalLoading) {
                        return;
                      }
                      showGlobalLoading();

                      helpCypher(cypherKey);
                    }}
                  >
                    <AiFillFire
                      color="white"
                      size={22}
                    />
                    <div className=" mt-0 text-nowrap whitespace-nowrap text-sm">为TA助力</div>
                  </div>
                )} */}
                {/* 分享助力 */}
                <div
                  className=" flex items-center justify-center gap-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-2 py-2 rounded-md shadow-md text-base"
                  onClick={() => {
                    if (globalLoading) {
                      return;
                    }
                    showGlobalLoading();

                    shareCypher({
                      cypher: cypherData.cypherKey,
                      postId: cypherData.fkPostId,
                      postTitle: cypherData.postTitle,
                      postCover: cypherData.postCover,
                      postSourceType: cypherData.postSourceType,
                    });
                  }}
                >
                  <AiOutlineShareAlt size={22} />
                  <div className=" mt-0 text-nowrap whitespace-nowrap text-sm">分享助力</div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* 异次元空间 */}
        <div
          className={[
            baseUsergroup ? ' visible' : ' invisible',
            ' mt-4 text-slate-300 py-2 flex justify-center items-center gap-2 underline underline-offset-4 text-base',
          ].join(' ')}
          onClick={useThrottledHandler(async () => {
            if (userPolyInfo.vipList?.length > 0) {
              navigate('/one/osusume');
            } else {
              setShowLevelupModel(true);
            }
          })}
        >
          <AiOutlineRight />
          <span>异次元空间</span>
          <AiOutlineLeft />
        </div>
        {/* 盲盒 */}
        <div className=" text-center flex item-center justify-center">
          <AiOutlineGift
            size={40}
            color="purple"
            className={[
              !todayOverGift ? ' visible' : ' invisible',
              ' m-1 bg-gradient-to-br from-pink-500 to-orange-500 rounded-md shadow-md',
            ].join(' ')}
            onClick={useThrottledHandler(() => {
              if (globalLoading) {
                return;
              }
              showGlobalLoading();

              PostsApi.pageOsusume({ termId: null, count: 4 }).then((resp) => {
                if (resp.successful) {
                  // 显示盲盒内容
                  const result: PagePostDT[] = resp.result.records;
                  setGiftModalData(result);
                  setShowGiftModal(true);
                }
              });
            })}
          />
        </div>
        {/* 浮动面板 */}
        <FloatingPanel
          ref={floatingPanelRef}
          anchors={[
            115,
            // Math.max(115, window.innerWidth * 0.4),
            initialHeight * 0.69,
            // initialHeight * 0.95
          ]}
          style={{
            '--border-radius': '30px',
            '--header-height': '30px',
            overflow: 'hidden',
          }}
          className=" overflow-hidden"
          // className={myStyles.customCss}
          handleDraggingOfContent={false} // 牺牲便捷性，去除滚动冲突
          onHeightChange={(height: number, animating: boolean) => {
            if (!animating && height === initialHeight * 0.69) {
              // 动画结束且到达顶部，刷新点数和历史列表和助力列表
              showGlobalLoading();
              getRemainCrackTimesMap();
              fetchCollect('history');
              getUserPoint();
            }
          }}
        >
          {/* 背景 */}
          {true && (
            <div
              style={{
                background: `url(${img.splash}) center top / cover no-repeat`,
                width: window.innerWidth,
                height: initialHeight * 0.69 - 30,
                position: 'fixed',
              }}
              className="z-0 "
            />
          )}
          {/* 主体 */}
          <div
            style={{
              minHeight: initialHeight * 0.69 - 30,
            }}
          >
            {/* 基本交互 */}
            {true && (
              <div className={['relative z-10 '].join(' ')}>
                {/* 背景 */}
                {true && (
                  <>
                    <div
                      style={{
                        width: '100%',
                        height: 90,
                        overflow: 'hidden',
                        position: 'relative',
                      }}
                    >
                      <div
                        style={{
                          background: `url(${img.splash})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center top',
                          backgroundRepeat: 'no-repeat',
                          width: window.innerWidth,
                          height: 90,
                          position: 'fixed',
                          top: 30,
                          overflow: 'hidden',
                        }}
                      />
                    </div>
                  </>
                )}
                {/* 具体交互 */}
                {true && (
                  <div
                    style={{
                      height: 90,
                      marginTop: 30,
                      width: window.innerWidth,
                    }}
                    className={[
                      ' backdrop-blur-sm ',
                      ' backdrop-brightness-75',
                      ' fixed top-0 w-full flex items-center justify-between px-4',
                    ].join(' ')}
                  >
                    {/* 每日签到 */}
                    <div
                      className=" text-center bg-purple-400 text-slate-100 shadow-md rounded-md bg-opacity-90 p-2"
                      onClick={() => {
                        if (!todayOverSign) {
                          if (globalLoading) {
                            return;
                          }
                          showGlobalLoading();

                          // 用户签到
                          ClockApi.userSign(userId).then((resp) => {
                            if (resp.successful) {
                              const result: ClockDataType = resp.result;
                              Modal.show({
                                title: <b>签到成功</b>,
                                content: (
                                  <div className=" text-orange-500 text-center font-bold w-full">
                                    {result.awardTips}
                                  </div>
                                ),
                                closeOnMaskClick: true,
                                closeOnAction: true,
                                showCloseButton: true,
                              });
                              getTodayOverSign();
                              getUserPoint();
                            }
                          });
                        } else {
                          fetchRecordList();
                          setRecordSwiperIndex(0);
                          setShowRecordsModal(true);
                        }
                      }}
                    >
                      {!todayOverSign ? (
                        <>
                          <div>每日签到</div>
                          <div>点击签到</div>
                        </>
                      ) : (
                        <>
                          <div>每日签到</div>
                          <div>{`${todayOverSign?.awardPointCount == 9 ? '大吉' : todayOverSign?.awardPointCount == 6 ? '中吉' : '小吉'} + ${todayOverSign?.awardPointCount}`}</div>
                        </>
                      )}
                    </div>
                    {/* 滑块 */}
                    <div className=" bg-slate-100 bg-opacity-90 px-2 py-4 rounded-md shadow-md text-base text-center">
                      {['历史记录', '我的收藏'].map((item, index) => (
                        <span
                          key={item + index}
                          className={[
                            ' m-2 mx-3',
                            postSwiperIndex === index ? 'text-orange-500' : 'text-slate-500 ',
                          ].join(' ')}
                          onClick={() => {
                            postSwipeRef.current?.swipeTo(index);
                            setPostSwiperIndex(index);
                          }}
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                    {/* 我的点数 */}
                    <div
                      className=" text-center bg-pink-400 text-slate-100 shadow-md rounded-md bg-opacity-90 p-2"
                      onClick={() => {
                        if (globalLoading) {
                          return;
                        }

                        getUserPoint();
                        fetchRecordList();
                        setRecordSwiperIndex(1);
                        setShowRecordsModal(true);
                      }}
                    >
                      <div>我的点数</div>
                      <div>{userPoint}</div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* 内容滑块 */}
            {true && (
              <Swiper
                ref={postSwipeRef}
                style={{
                  // marginTop: 90,
                  minHeight: initialHeight * 0.69 - 30 - 90,
                }}
                className={[' backdrop-blur-sm ', ' backdrop-brightness-75'].join(' ')}
                defaultIndex={0}
                tabIndex={postSwiperIndex}
                indicator={(total, current) => <></>}
                onIndexChange={(index) => {
                  setPostSwiperIndex(index);
                  // document.getElementById('dataList' + index + '0')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {/* 历史记录,我的收藏 */}
                {[historyList, collectList].map((dataList, dataListIndex) => (
                  <Swiper.Item key={dataListIndex}>
                    <Grid
                      columns={3}
                      gap={8}
                      className={[' px-2 mb-12'].join(' ')}
                      style={{ width: window.innerWidth }}
                    >
                      {dataList?.slice(0, Math.min(limitCount, dataList.length))?.map((item, index) => {
                        return (
                          <Grid.Item
                            key={item.postUuid}
                            className=" bg-black bg-opacity-40 rounded-md shadow-xl"
                          >
                            <div
                              key={'dataList' + dataListIndex + index}
                              className={[
                                ' text-white rounded-2xl text-center shadow-md overflow-hidden flex flex-col justify-center items-center gap-2 m-1 py-1',
                              ].join(' ')}
                              onClick={() => {
                                navigate2Detail(
                                  {
                                    postCoverUrlList: [item.postCoverUrl],
                                    ...item,
                                  },
                                  item.termUuid
                                );
                              }}
                            >
                              <div className=" relative flex flex-col items-center justify-center gap-1 p-1">
                                {/* 封面 */}
                                <div className={[' relative inline-block'].join(' ')}>
                                  <Image
                                    src={item.postCoverUrl
                                      ?.replaceAll('\\', '/')
                                      .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                                    className=" rounded-md"
                                    width={Math.floor(window.innerWidth / 4)}
                                    height={Math.floor(window.innerWidth / 4)}
                                    fit="cover"
                                    lazy={true}
                                    fallback={
                                      <div
                                        style={{
                                          background:
                                            'url(' + img.fallbackVerticalImg + ') center center / cover no-repeat',
                                          height: Math.floor(window.innerWidth / 4),
                                          width: Math.floor(window.innerWidth / 4),
                                        }}
                                      />
                                    }
                                    placeholder={
                                      <div
                                        style={{
                                          background: 'url(' + img.loadingImg + ') center center / cover no-repeat',
                                          height: Math.floor(window.innerWidth / 4),
                                          width: Math.floor(window.innerWidth / 4),
                                        }}
                                      />
                                    }
                                  />
                                  <div className=" absolute top-0 right-0 p-1 rounded-md bg-orange-500 bg-opacity-80 shadow-md">
                                    {postSourceTypeMap.get(item.postSourceType)}
                                  </div>
                                </div>
                                {/* 标题 */}
                                <Ellipsis
                                  content={item.postTitle}
                                  rows={2}
                                  direction="end"
                                  className=" text-xs/3 -mt-0.5 -mb-1 h-9 overflow-hidden"
                                />
                                {/* 蒙版 */}
                                <div
                                  className={[
                                    !(overCrackTimesMap.get(item.postUuid) >= 3) ? 'visible' : 'hidden',
                                    ' text-sm bg-black bg-opacity-60 w-full h-full absolute top-0 left-0 rounded-md shadow-md flex flex-col justify-center items-center',
                                  ].join(' ')}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }}
                                >
                                  <div>
                                    还需
                                    <span className=" inline-block pl-2 pr-1.5 py-0.5 mr-1 shadow-sm rounded-sm bg-slate-500">
                                      {3 - (overCrackTimesMap.get(item.postUuid) || 0)}
                                    </span>
                                    助力
                                  </div>
                                  <div
                                    className=" underline underline-offset-4 text-white text-sm mt-2"
                                    onClick={() => {
                                      if (globalLoading) {
                                        return;
                                      }
                                      showGlobalLoading();

                                      crackCypher(userId, item.postUuid);
                                    }}
                                  >
                                    点数解锁
                                  </div>
                                </div>
                              </div>
                              {/* 交互 */}
                              <div className=" flex items-center justify-center gap-1.5">
                                {/* 资源 */}
                                {overCrackTimesMap.get(item.postUuid) >= 3 && (
                                  <>
                                    <div
                                      className={[
                                        ' flex items-center justify-center gap-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white px-2 py-1.5 rounded-md shadow-md',
                                      ].join(' ')}
                                    >
                                      <AiOutlineExpand size={16} />
                                      <div className=" mt-0 text-nowrap text-sm">资源</div>
                                    </div>
                                  </>
                                )}
                                {/* 分享助力 */}
                                <div
                                  className=" flex items-center justify-center gap-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-2 py-1.5 rounded-md shadow-md"
                                  onClick={(e) => {
                                    if (globalLoading) {
                                      return;
                                    }
                                    showGlobalLoading();

                                    e.preventDefault();
                                    e.stopPropagation();
                                    shareCypher({
                                      cypher: '待生成',
                                      postId: item.postUuid,
                                      postTitle: item.postTitle,
                                      postCover: item.postCoverUrl,
                                      postSourceType: item.postSourceType,
                                    });
                                  }}
                                >
                                  <AiOutlineShareAlt size={16} />
                                  <div
                                    className={[
                                      !(overCrackTimesMap.get(item.postUuid) >= 3) ? 'visible' : 'hidden',
                                      ' mt-0 text-nowrap text-sm',
                                    ].join(' ')}
                                  >
                                    分享助力
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Grid.Item>
                        );
                      })}
                    </Grid>

                    <center>
                      <div className=" p-2 w-40 bg-slate-400/80 mb-24 text-white rounded-md shadow-md">
                        {dataList?.length == 0
                          ? `暂无记录，快去探索吧`
                          : dataList?.length < limitCount
                            ? `没有更多记录`
                            : `只显示最近 ${limitCount} 条记录`}
                      </div>
                    </center>
                  </Swiper.Item>
                ))}
              </Swiper>
            )}
          </div>
        </FloatingPanel>
      </div>
    </>
  );
};

export default Sesame;
